import { makeApiActionCreatorV3 } from '@actions/utils';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';

import * as api from '../api/search';

const namespace = 'MOBILE';

export const SEARCH_START = `${namespace}/SEARCH_START`;
export const SEARCH_SUCCESS = `${namespace}/SEARCH_SUCCESS`;
export const SEARCH_ERROR = `${namespace}/SEARCH_ERROR`;

export const search = makeApiActionCreatorV3(
  api.search,
  SEARCH_START,
  SEARCH_SUCCESS,
  SEARCH_ERROR,
);

export const FETCH_SEARCH_PARAMS = createRequestTypes(
  `${namespace}/FETCH_SEARCH_PARAMS`,
);

export const fetchSearchParams = makeApiActionCreatorV3(
  api.fetchSearchParams,
  FETCH_SEARCH_PARAMS[START],
  FETCH_SEARCH_PARAMS[SUCCESS],
  FETCH_SEARCH_PARAMS[ERROR],
);

export const FETCH_SEARCH_PARAM = createRequestTypes(
  `${namespace}/FETCH_SEARCH_PARAM`,
);

export const fetchSearchParam = makeApiActionCreatorV3(
  api.fetchSearchParam,
  FETCH_SEARCH_PARAM[START],
  FETCH_SEARCH_PARAM[SUCCESS],
  FETCH_SEARCH_PARAM[ERROR],
);

export const INSERT_SEARCH_PARAM = createRequestTypes(
  `${namespace}/INSERT_SEARCH_PARAM`,
);

export const insertSearchParam = makeApiActionCreatorV3(
  api.insertSearchParam,
  INSERT_SEARCH_PARAM[START],
  INSERT_SEARCH_PARAM[SUCCESS],
  INSERT_SEARCH_PARAM[ERROR],
);

export const UPDATE_SEARCH_PARAM = createRequestTypes(
  `${namespace}/UPDATE_SEARCH_PARAM`,
);

export const updateSearchParam = makeApiActionCreatorV3(
  api.updateSearchParam,
  UPDATE_SEARCH_PARAM[START],
  UPDATE_SEARCH_PARAM[SUCCESS],
  UPDATE_SEARCH_PARAM[ERROR],
);

export const DUPLICATE_SEARCH_PARAM = createRequestTypes(
  `${namespace}/DUPLICATE_SEARCH_PARAM`,
);

export const duplicateSearchParam = makeApiActionCreatorV3(
  api.duplicateSearchParam,
  DUPLICATE_SEARCH_PARAM[START],
  DUPLICATE_SEARCH_PARAM[SUCCESS],
  DUPLICATE_SEARCH_PARAM[ERROR],
);

export const DELETE_SEARCH_PARAM = createRequestTypes(
  `${namespace}/DELETE_SEARCH_PARAM`,
);

export const deleteSearchParam = makeApiActionCreatorV3(
  api.deleteSearchParam,
  DELETE_SEARCH_PARAM[START],
  DELETE_SEARCH_PARAM[SUCCESS],
  DELETE_SEARCH_PARAM[ERROR],
);

export const DELETE_ASSIGNMENT = createRequestTypes(
  `${namespace}/DELETE_ASSIGNMENT`,
);

export const deleteAssignment = makeApiActionCreatorV3(
  api.deleteAssignment,
  DELETE_ASSIGNMENT[START],
  DELETE_ASSIGNMENT[SUCCESS],
  DELETE_ASSIGNMENT[ERROR],
);

export const RESET_SEARCH_PARAM = `${namespace}/RESET_SEARCH_PARAM`;

export const resetSearchParam = () => ({
  type: RESET_SEARCH_PARAM,
});

export const SET_SEARCH_PARAM = `${namespace}/SET_SEARCH_PARAM`;

export const setSearchParam = searchParamID => ({
  type: SET_SEARCH_PARAM,
  searchParamID,
});

export const SET_SEARCH_FORM_DATA = `${namespace}/SET_SEARCH_FORM_DATA`;
export const setFormData = formData => ({
  type: SET_SEARCH_FORM_DATA,
  payload: formData,
});
